// Global variable to store custom API URL
let globalApiUrl: string | undefined;

export const setGlobalApiUrl = (apiUrl: string) => {
	globalApiUrl = apiUrl;
};

export const getGlobalApiUrl = () => globalApiUrl;
